import type { ClientQuestion, LocaleCode } from '@fixit/bozp-content';
import { resolveLocalized } from '../locale';

export interface NumericProps {
  question: Extract<ClientQuestion, { kind: 'numeric' }>;
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  locale: LocaleCode;
}

/** kind: 'numeric' — emits a parsed number, or undefined for blank/invalid (never NaN). */
export function Numeric({ question, value, onChange, locale }: NumericProps) {
  return (
    <div data-quiz-kind="numeric">
      <label>
        {resolveLocalized(question.prompt, locale)}
        <input
          type="number"
          value={value ?? ''}
          onChange={(e) => {
            const raw = e.target.value;
            if (raw === '') {
              onChange(undefined);
              return;
            }
            const parsed = Number(raw);
            onChange(Number.isFinite(parsed) ? parsed : undefined);
          }}
        />
      </label>
    </div>
  );
}
